import { Component, OnInit } from '@angular/core';
import { BillingSummaryHeader } from './billing-summary-header/billing-summary-header';
import { ContractsTable } from './contracts-table/contracts-table';
import { ApiQuery } from '../../../web-services/api/api.query';
import { ApiService } from '../../../web-services/api/api.service';
import { CommonModule } from '@angular/common';
import { combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';
import moment from 'moment';

@Component({
  selector: 'app-overview',
  imports: [CommonModule, ContractsTable, BillingSummaryHeader],
  templateUrl: './overview.html',
  styleUrl: './overview.scss',
})
export class Overview implements OnInit {
  mergedData: any[] = [];

  constructor(private apiService: ApiService, private apiQuery: ApiQuery) {}

  ngOnInit(): void {
    this.apiQuery.user$.subscribe((user: any) => {
      if (!user || !user.account_id) { return; }
      this.apiService.getContracts(user.account_id);
    });

    this.callContractStatus();

    combineLatest([
      this.apiQuery.contractsData$,
      this.apiQuery.contractStatusData$
    ]).pipe(
      filter(([contracts, status]) => !!contracts && contracts.length > 0 && !!status?.contract_status?.length)
    ).subscribe(([contracts, status]: [any[], any]) => {
      const statusArray: any[] = status.contract_status;
      this.mergedData = contracts.map((contract: any) => {
        const matchingStatus = statusArray.find((s: any) => s.contract_id === contract.contract_id);
        if (!matchingStatus) return { ...contract };
        const merged: any = { ...contract };
        Object.keys(matchingStatus).forEach(key => {
          if (!(key in merged)) { merged[key] = matchingStatus[key]; }
        });
        return merged;
      });
    });
  }

  private callContractStatus(): void {
    const start_date = moment().startOf('month').format('YYYY-MM-DD') + ' 00:00:01';
    const end_date   = moment().endOf('month').format('YYYY-MM-DD')   + ' 23:59:59';
    this.apiService.getContractStatus({
      contract_id: 0,
      start_date,
      end_date
    });
  }
}
